import { render, staticRenderFns } from "./ClientRedirections.vue?vue&type=template&id=77e3515f&scoped=true&"
import script from "./ClientRedirections.vue?vue&type=script&lang=js&"
export * from "./ClientRedirections.vue?vue&type=script&lang=js&"
import style0 from "./ClientRedirections.vue?vue&type=style&index=0&id=77e3515f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3515f",
  null
  
)

export default component.exports